import { actionTypes } from '../actions/types';

type AppActions = import('../actions/types').AppActions;

export interface LoaderReducer {
    [k: string]: boolean;
}
export const initialState: LoaderReducer = {
    isLoggedIn: false,

    /* Fetching */
    isFetchingUserSession: false,
    isFetchingUserContext: false,
    isFetchingAgriMember: false,
    isFetchingNafCache: false,
    isFetchingNafMember: false,
    isFetchingStatus: false,
    isFetchingCards: false,
    isFetchingKdk: false,
    isFetchingSigningUrl: false,
    isFetchingSblConsent: false,
    isFetchingCase: false,

    /* Fetced */
    hasFetchedUserSession: false,
    hasFetchedUserContext: false,
    hasFetchedAgriMember: false,
    hasFetchedNafCache: false,
    hasFetchedNafMember: false,
    hasFetchedStatus: false,
    hasFetchedCards: false,
    hasFetchedKdk: false,
    hasFetchedConsent: false,
    hasFetchedSigningUrl: false,
    hasFetchedSblConsent: false,
    hasFetchedCase: false,

    /* Sending */
    isSendingApplication: false,
    isSendingFeedback: false,
    isSendingOrder: false,
    isCompletingOrder: false,

    /* Sent */
    hasSentApplication: false,
    hasSentFeedback: false,
    hasSentOrder: false,
    hasCompletedOrder: false,

    /* Creating */
    isCreatingSblConsent: false,
};

export const loaderReducer = (state = initialState, action: AppActions = {} as AppActions): LoaderReducer => {
    switch (action.type) {
        /* Fetch User Session */
        case actionTypes.FETCH_USER_SESSION_STARTED: {
            return {
                ...state,
                isFetchingUserSession: true,
            };
        }
        case actionTypes.FETCH_USER_SESSION_FULFILLED: {
            return {
                ...state,
                isFetchingUserSession: false,
                hasFetchedUserSession: true,
                isLoggedIn: action.payload.valid,
            };
        }
        case actionTypes.FETCH_USER_SESSION_FAILED: {
            return {
                ...state,
                isFetchingUserSession: false,
            };
        }

        /* Fetch User Context */
        case actionTypes.FETCH_USER_CONTEXT_STARTED: {
            return {
                ...state,
                isFetchingUserContext: true,
            };
        }
        case actionTypes.FETCH_USER_CONTEXT_FULFILLED: {
            return {
                ...state,
                isFetchingUserContext: false,
                hasFetchedUserContext: true,
            };
        }
        case actionTypes.FETCH_USER_CONTEXT_FAILED: {
            return {
                ...state,
                isFetchingUserContext: false,
            };
        }

        /* Fetch Agri Member */
        case actionTypes.FETCH_AGRI_MEMBER_STARTED: {
            return {
                ...state,
                isFetchingAgriMember: true,
            };
        }
        case actionTypes.FETCH_AGRI_MEMBER_FULFILLED: {
            return {
                ...state,
                isFetchingAgriMember: false,
                hasFetchedAgriMember: true,
            };
        }
        case actionTypes.FETCH_AGRI_MEMBER_FAILED: {
            return {
                ...state,
                isFetchingAgriMember: false,
            };
        }

        /* Fetch NAF Cache */
        case actionTypes.FETCH_NAF_CACHE_STARTED: {
            return {
                ...state,
                isFetchingNafCache: true,
            };
        }
        case actionTypes.FETCH_NAF_CACHE_FULFILLED: {
            return {
                ...state,
                isFetchingNafCache: false,
                hasFetchedNafCache: true,
            };
        }
        case actionTypes.FETCH_NAF_CACHE_FAILED: {
            return {
                ...state,
                isFetchingNafCache: false,
            };
        }

        /* Fetch NAF Member */
        case actionTypes.FETCH_NAF_MEMBER_STARTED: {
            return {
                ...state,
                isFetchingNafMember: true,
            };
        }
        case actionTypes.FETCH_NAF_MEMBER_FULFILLED: {
            return {
                ...state,
                isFetchingNafMember: false,
                hasFetchedNafMember: true,
            };
        }
        case actionTypes.FETCH_NAF_MEMBER_FAILED: {
            return {
                ...state,
                isFetchingNafMember: false,
            };
        }

        /* Fetch Status */
        case actionTypes.FETCH_STATUS_STARTED: {
            return {
                ...state,
                isFetchingStatus: true,
            };
        }
        case actionTypes.FETCH_STATUS_FULFILLED: {
            return {
                ...state,
                isFetchingStatus: false,
                hasFetchedStatus: true,
            };
        }
        case actionTypes.FETCH_STATUS_FAILED: {
            return {
                ...state,
                isFetchingStatus: false,
            };
        }

        case actionTypes.FETCH_CASE_STARTED: {
            return {
                ...state,
                isFetchingCase: true,
            };
        }
        case actionTypes.FETCH_CASE_FULFILLED: {
            return {
                ...state,
                isFetchingCase: false,
            };
        }
        case actionTypes.FETCH_CASE_FAILED: {
            return {
                ...state,
                isFetchingCase: false,
            };
        }

        /* Send Application */
        case actionTypes.SEND_APPLICATION_STARTED: {
            return {
                ...state,
                isSendingApplication: true,
            };
        }
        case actionTypes.SEND_APPLICATION_FULFILLED: {
            return {
                ...state,
                isSendingApplication: false,
                hasSentApplication: true,
            };
        }
        case actionTypes.SEND_APPLICATION_FAILED: {
            return {
                ...state,
                isSendingApplication: false,
            };
        }

        // Send Feedback
        case actionTypes.SEND_FEEDBACK_STARTED: {
            return {
                ...state,
                isSendingFeedback: true,
            };
        }
        case actionTypes.SEND_FEEDBACK_FULFILLED: {
            return {
                ...state,
                isSendingFeedback: false,
                hasSentFeedback: true,
            };
        }
        case actionTypes.SEND_FEEDBACK_FAILED: {
            return {
                ...state,
                isSendingFeedback: false,
            };
        }

        /* Send Order */
        case actionTypes.SEND_ORDER_STARTED: {
            return {
                ...state,
                isSendingOrder: true,
            };
        }
        case actionTypes.SEND_ORDER_FULFILLED: {
            return {
                ...state,
                isSendingOrder: false,
                hasSentOrder: true,
            };
        }
        case actionTypes.SEND_ORDER_FAILED: {
            return {
                ...state,
                isSendingOrder: false,
            };
        }

        /* Complete Order */
        case actionTypes.COMPLETE_ORDER_STARTED: {
            return {
                ...state,
                isCompletingOrder: true,
            };
        }
        case actionTypes.COMPLETE_ORDER_FULFILLED: {
            return {
                ...state,
                isCompletingOrder: false,
                hasCompletedOrder: true,
            };
        }
        case actionTypes.COMPLETE_ORDER_FAILED: {
            return {
                ...state,
                isCompletingOrder: false,
            };
        }

        /* Fetch Cards */
        case actionTypes.FETCH_CARDS_STARTED: {
            return {
                ...state,
                isFetchingCards: true,
            };
        }
        case actionTypes.FETCH_CARDS_FULFILLED: {
            return {
                ...state,
                isFetchingCards: false,
                hasFetchedCards: true,
            };
        }
        case actionTypes.FETCH_CARDS_FAILED: {
            return {
                ...state,
                isFetchingCards: false,
            };
        }

        /* Fetch Consent */
        case actionTypes.FETCH_CONSENT_STARTED: {
            return {
                ...state,
                isFetchingConsent: true,
            };
        }
        case actionTypes.FETCH_CONSENT_FULFILLED: {
            return {
                ...state,
                isFetchingConsent: false,
                hasFetchedConsent: true,
            };
        }
        case actionTypes.FETCH_CONSENT_FAILED: {
            return {
                ...state,
                isFetchingConsent: false,
            };
        }

        case actionTypes.CREATE_SBL_CONSENT_STARTED: {
            return {
                ...state,
                isCreatingSblConsent: true,
            };
        }
        case actionTypes.CREATE_SBL_CONSENT_FULFILLED:
        case actionTypes.CREATE_SBL_CONSENT_FAILED: {
            return {
                ...state,
                isCreatingSblConsent: false,
            };
        }

        default:
            return state;
    }
};
